import styled from "styled-components";
import * as SelectPane from "../../../../../../../common-deprecated/styles/v2/toyota/custom/SelectPane";
import * as Modal from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div`
    text-align: start;

    /* Set max-width on modal */
    ${Modal.Dialog} {
        @media ${getBreakpoint("up", "md")} {
            max-width: 375px !important; /* Needed an important to override CSS */
        }
    }

    /* Override select pane in modal. Shouldn't be absolute/fixed positioned */
    ${SelectPane.Wrapper} {
        position: static;
        top: auto;
        left: auto;
        right: auto;
    }
`;
